const flights = {
  flight: "טִיסָה", // translated
  flights: "טיסות", // translated
  originDepartureDate: "יְצִיאָה", // translated
  destinationDepartureDate: "לַחֲזוֹר", // translated
  outbound: "יוצא", // translated
  inbound: "נכנסת", // translated
  travelTime: "זמן נסיעה", // translated
  selected: "נבחר", // translated
  select: "בחר", // translated
  airline: "חֶברַת תְעוּפָה", // translated
  directFlight: "טיסה ישירה", // translated
  baggage: "כבודה", // translated
  stops: "מפסיק", // translated
  nonStop: "ללא הפסקה", // translated
  oneStopMax: "תחנה אחת מקסימום", // translated
  twoStopsMax: "שתי עצירות מקסימום", // translated
  anyStops: "עם כל עצירות", // translated
  smallBaggage: "מטען קטן", // translated
  bigBaggage: "מטען גדול", // translated
  smallAndBigBaggage: "מטען קטן וגדול", // translated
  outboundStops: "עצירות יוצאות", // translated
  inboundStops: "עצירות נכנסות", // translated
  selectAirline: "בחר חברת תעופה", // translated
  baggageOption: "אפשרות לכבודה", // translated
  outboundDepartureAfter: "יציאה החוצה לאחר", // translated
  outboundArrivalAfter: "הגעה יוצאת לאחר", // translated
  inboundDepartureAfter: "יציאה נכנסת לאחר", // translated
  inboundArrivalTimeAfter: "הגעה נכנסת אחרי", // translated
  flightClass: "מחלקת טיסה", // translated
  outboundDepAfter: "יציאה החוצה אחרי", // translated
  outboundArrivalAfrer: "יוצא הגעה אחרי", // translated
  inboundDepAfter: "ביציאה אחרי", // translated
  inboundArrivalAfter: "בהגעה אחרי", // translated
  airlines: "חברות תעופה", // translated
  lessThan: "פחות מ", // translated
  layover: "עצירת ביניים", // translated
  duration: "מֶשֶׁך", // translated
  economy: "כַּלְכָּלָה", // translated
  business: "עֵסֶק", // translated
  with: "עם", // translated
  without: "לְלֹא", // translated
  twoOrMore: "שתיים או יותר", // translated
  departure: "יְצִיאָה", // translated
  return: "לַחֲזוֹר", // translated
  submit: "שלח", // translated
  priceLessThan: "מחיר פחות מ", // translated
  durationLessThan: "משך פחות מ", // translated
  layoverLessThan: "עצירת ביניים פחות מ", // translated
  noLayover: "אין עצירת ביניים", // translated
  durationLowestFirst: "משך זמן (הנמוך ביותר ראשון)", // translated
  durationHighestFirst: "משך זמן (הגבוה ביותר ראשון)", // translated
  idType: "סוג מזהה", // translated
  idPassportCode: "קוד תעודה מזהה/דרכון", // translated
  expirationDate: "תאריך תפוגה", // translated
  frequentFlyerNumber: "מספר נוסע מתמיד", // translated
  frequentFlyerAirline: "חברת נוסע מתמיד", // translated
  dateOfBirth: "תאריך לידה", // translated
  infant: "תִינוֹק", // translated
  phone: "טלפון", // translated
  title: "כותרת", // translated
  noLuggageIncluded: "לא כלול מזוודות", // translated
  includesLuggage: "כולל מזוודות", // translated
  outboundFlight: "טיסה יוצאת", // translated
  inboundFlight: "טיסה נכנסת", // translated
  flightNumber: "מספר טיסה", // translated
  flightNumbers: "מספרי טיסה", // translated
  cabinClassType: "סוג תא תא", // translated
  aircraftType: "סוג מטוס", // translated
  airlineName: "שם חברת התעופה", // translated
  no: "לא", // translated
  yes: "כן", // translated
  anyFlights: "כל טיסות", // translated
  oneStop: "עצירה אחת", // translated
  direct: "ישיר", // translated
  directFlights: "טיסות ישירות", // translated
  all: "את כל", // translated
  first: "ראשון", // translated
  premiumEconomy: "Prem. כַּלְכָּלָה", // translated
  withBaggageOnly: "עם מטען בלבד", // translated
  oneWay: "דרך אחת", // translated
  roundTrip: "נסיעה הלוך ושוב", // translated
  withBaggage: "עם מזוודות", // translated
  noBaggage: "אין מטען", // translated
  requiredFields: "שדות חובה", // translated
  nonRequiredFields: "שדות לא חובה", // translated
  cabinClass: "מחלקת בקתה", // translated
  brandName: "שם מותג", // translated
  performNewSearch: "בצע חיפוש חדש", // translated
  outboundDeparture: "יציאה יוצאת", // translated
  inboundDeparture: "יציאה נכנסת", // translated
  created: "נוצר", // translated
  freeCancellationAvailable: "ביטול חינם זמין", // translated
  freeCancellationDeadline: "מועד אחרון לביטול חינם", // translated
  externalReference: "התייחסות חיצונית", // translated
  outboundflightNumber: "מספר טיסה יוצאת", // translated
  inboundflightNumber: "מספר טיסה נכנסת", // translated
  arrival: "הַגָעָה", // translated
};

export default flights;
